import type { Service } from '../types'

export const services: Service[] = [
  {
    title: 'Music & Sound',
    items: [
      'Artist Collaborations',
      'Bespoke Compositions',
      'Licensing',
      'Music Supervision',
      'Sonic Branding',
      'Sound Design',
      'Strategy',
      'Sync',
      'Talent Casting',
    ],
  },
  {
    title: 'Post-Production',
    items: [
      'Color Grading',
      'Finishing',
      'Motion Design',
      'Offline Editing',
      'VFX Supervision',
    ],
  },
  {
    title: 'Experiential',
    items: [
      'Brand Activations',
      'Event Organization',
      'Festival Activations',
      'Immersive Technologies',
      'Installations',
      'Live Production',
      'Product Launches',
      'Spatial Design',
    ],
  },
]
